import { AuthService } from '@card-software/nexus-utilities';
import { UserManagerAdminGroup } from '@app/models/authorization/enum/user-group.enum';
import { USER_MANAGEMENT_ADMIN_ROLES } from '@app/models/roles/roles.group';

/**
 * Delegated (external) user manager: holds UserManagerDelegate and not the user admin role (UserManagementAdmin).
 * A user with both is an internal admin (Decision #6295), the same rule the API applies.
 */
export function isDelegatedUserManager(): boolean {
  return (
    AuthService.hasRole(UserManagerAdminGroup.UserManagerDelegate) && !USER_MANAGEMENT_ADMIN_ROLES.some((role) => AuthService.hasRole(role))
  );
}
